import { render } from "./editRect.vue?vue&type=template&id=1f7ca362&scoped=true"
import script from "./editRect.vue?vue&type=script&lang=js"
export * from "./editRect.vue?vue&type=script&lang=js"

import "./editRect.vue?vue&type=style&index=0&id=1f7ca362&scoped=true&lang=css"

import exportComponent from "C:\\vue2025\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7ca362"]])

export default __exports__